import { render, staticRenderFns } from "./BidsPartsPage.vue?vue&type=template&id=126eb8b6"
import script from "./BidsPartsPage.vue?vue&type=script&lang=js"
export * from "./BidsPartsPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports